import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { SparklesIcon } from './Icons';
import '../styles/Sponsors.css';

const Sponsors: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleBack = () => {
    if (user?.role) {
      const normalizedRole = user.role.toUpperCase().replace('-', '_');
      if (normalizedRole === 'STUDENT') {
        navigate('/dashboard/student');
      } else {
        navigate('/');
      }
    } else {
      navigate('/');
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }}
      className="sponsors-page"
    >
      <button className="back-button" onClick={handleBack}>
        ← BACK
      </button>

      <div className="sponsors-header">
        <h1 className="sponsors-title">OUR SPONSORS</h1>
        <p className="sponsors-subtitle">Coming Soon...</p>
      </div>

      <div className="sponsors-content">
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="coming-soon-container"
        >
          <div className="coming-soon-icon"><SparklesIcon size={48} color="#00ffff" /></div>
          <h2 className="coming-soon-text">Coming Soon</h2>
          <p className="coming-soon-description">
            Exciting sponsors are on their way. Check back soon!
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Sponsors;
